import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from '../services';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { combineStates, currentNodeState, popupState } from '../store';
import { IconButton } from '../components';
import { getRouteToName } from '../util';
import { HelpImageViewer } from '../components/HelpImageViewer';
import { helpImage } from '../util';
// import { loadHelpImage } from '../util';
import { helpImagesState } from '../store';
import { loadHelpImage } from '../util/helpImageHelper';
import { combineDispatchers } from '../store';
import { popupDispatcher } from '../store';
export class NodeMessageComponent extends Component {

  onClick = () => {
    const { item } = this.props;
    let fromDisclaimerPopUp = true;
    let str = getRouteToName( item, fromDisclaimerPopUp );
    str = '#' + str;
    let url = window.location.origin + window.location.pathname + str;
    window.location.href = url;
    this.hidePopup();
  }

  hidePopup = () => this.props.hidePopup();

  // helpImage(){
  //   loadHelpImage();
  // }

  render() {
    // const { currentNode, item,
    //   actionText = translate( 'Ok' ),
    //   cancelText = translate( 'Cancel' ),
    // } = this.props;
    const { item, helpImages } = this.props;
    let currentImage = 'Disclaimer_1';
    var value = '';
    return <div className="node-message">
      <div className="popup-text-message">
        <p>
          <div>
            {
              //  value = this.props.helpImage()
               value = loadHelpImage(this.props)
              // <HelpImageViewer selectorName={ "Disclaimer" } filterName= { '1' } displayName={ item.name } />
              // <HelpImageHelper image={ currentImage } />
            }
          </div>
          {/* <div style={ { fontWeight: "bolder" } }>{ translate( 'Standards and approvals for the products' ) }</div>
          <div>{ translate( 'Products in this selection tool are designed tested and have third party approvals and markings in compliance with major international or local standards such as IEC/EN 60947-1, IEC/EN 60947-4-1, IEC/EN 60947-2, IEC/EN 60947-5-1 or UL 60947-4-1.' ) }</div>
          <div>{ translate( 'See "Standards" section inside 1SBC100220C0201 catalogue: Motor control and protection for rolling stock applications.' ) }</div>
          &nbsp; <div>{ translate( 'For applicable parts and description of railway rolling stock standards, see the “Standards” section and the technical data pages of respective products, inside 1SBC100220C0201 Motor control and protection for rolling stock applications.' ) }</div>
          &nbsp; <div style={ { fontWeight: "bolder" } }>{ translate( 'Guarantee' ) }</div>
          <div>{ translate( 'The information contained in this selection reflects the current state of our knowledge and aims to present our products and their possible applications as defined within the standards.' ) }</div>
          <div>{ translate( 'The product data, ratings and utilization conditions are indicated in the respective sections of this selection tool and the 1SBC100220C0201 catalogue for Motor control and protection for rolling stock applications; thus the information does not guarantee special utilizations or combination of characteristics that have not been defined or tested according to normalized values or test conditions defined with the standards.' ) }</div>
          &nbsp;  <div style={ { fontWeight: "bolder" } }>{ translate( 'Liability' ) }</div>
          <div>{ translate( 'The devices in this selection tool do not endanger safety when they are selected, mounted, commissioned, used, maintained and deposed with the rules and standards that apply to them.' ) }</div> */}
        </p>
      </div>
      <div className="node-actions">
        <IconButton className="Ok-action" text={ translate( 'OK' ) } onClick={ this.onClick } />
        <IconButton className="Cancel-action" text={ translate( 'Cancel' ) } onClick={ this.hidePopup } />
      </div><br></br><br></br><br></br>
    </div>;
  }
}

NodeMessageComponent.propTypes = {
  actionText: PropTypes.string,
  cancelText: PropTypes.string,
  item: PropTypes.shape( {
    image: PropTypes.string
  } ),
  hidePopup: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
  // type: PropTypes.oneOf( [PopupType.Warning, PopupType.Info, PopupType.Error, null] )
};

export const NodeMessage = connect( combineStates( currentNodeState, helpImagesState, popupState ), combineDispatchers( popupDispatcher ) )( NodeMessageComponent );